import React, { ButtonHTMLAttributes } from 'react'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
  onClick?: (e: React.FormEvent<HTMLButtonElement>) => void
}

const Button: React.FC<ButtonProps> = ({ className, onClick, children, ...rest }) => {
  return (
    <button className={className} onClick={onClick} {...rest}>
      {children}
    </button>
  )
}

export default Button
